/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { Dashicon } from '@wordpress/components'
import { Fragment } from '@wordpress/element'
import { PlainText } from '@wordpress/block-editor'
import { compose } from '@wordpress/compose'
import ServerSideRender from '@wordpress/server-side-render'

/**
 * External dependencies
 */
import classnames from 'classnames'

import { withUniqueClass } from '~cartzillagb/higher-order'

const edit = ( {
	attributes, setAttributes, isSelected 
} ) => {
	const {
		label, placeholder, text, className, uniqueClass 
	} = attributes
	const inputId = `czgb-shortcode-blocks-input-${ uniqueClass }`

	const mainClasses = classnames( [
		'czgb-shortcode',
		uniqueClass,
		'components-placeholder',
		className,
	] )

	const inputControl = (
		<div className={ mainClasses }>
			<label htmlFor={ inputId } className="components-placeholder__label czgb-cartzillagb-icon-gradient text-primary">
				<Dashicon icon="shortcode" />
				{ label ? label : __( 'Shortcode' ) }
			</label>
			<PlainText
				className="input-control"
				id={ inputId }
				value={ text }
				placeholder={ placeholder ? placeholder : __( 'Write shortcode here…' ) }
				onChange={ text => setAttributes( { text } ) }
			/>
		</div>
	)

	const outputContent = (
		<ServerSideRender
			block="czgb/shortcode"
			attributes={ attributes }
		/>
	)

	return (
		<Fragment>
			{ ! text || isSelected ? inputControl : outputContent }
		</Fragment>
	)
}

export default compose(
	withUniqueClass,
)( edit )
